/** Canonical store types for receiving / inventory. */
export const STORE_TYPES = [
  { value: 'BONDED', label: 'Bonded' },
  { value: 'POL', label: 'POL' },
  { value: 'QUARANTINE', label: 'Quarantine' },
  { value: 'SCRAPE', label: 'Scrape' },
  { value: 'TOOLS', label: 'Tools' }
];

const STORE_TYPE_BY_VALUE = new Map(STORE_TYPES.map((t) => [t.value, t]));
const STORE_TYPE_BY_LABEL = new Map(
  STORE_TYPES.map((t) => [t.label.toUpperCase(), t.value])
);

/** Maps stored value or legacy label to a dropdown value, or '' if unset/unknown. */
export function normalizeStoreTypeValue(raw) {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  const upper = trimmed.toUpperCase();
  if (STORE_TYPE_BY_VALUE.has(upper)) return upper;
  return STORE_TYPE_BY_LABEL.get(upper) || '';
}

export function formatStoreTypeLabel(raw) {
  const value = normalizeStoreTypeValue(raw);
  if (!value) {
    const trimmed = String(raw || '').trim();
    return trimmed || '—';
  }
  return STORE_TYPE_BY_VALUE.get(value)?.label || value;
}
